const NetworkFormReviewNotice = ({ children }) => (
  <aside className="disclaimer" role="status">
    <p>{children}</p>
  </aside>
);

export default NetworkFormReviewNotice;
